import clsx from 'clsx'
import { formatMoney } from '../../../helpers/currency-formatter'

interface PriceProps {
  price: string
  compareAtPrice?: string
  containerClass?: string
  priceClass?: string
}

export function Price({ price, compareAtPrice, containerClass, priceClass }: PriceProps) {
  const isOnSale = parseFloat(price) < parseFloat(compareAtPrice || '0')

  const moneyFormat = window.globals?.shopify?.moneyFormat || '${{amount}}'

  const formatPrice = (value: string) => {
    if (!value) return ''

    const priceInCents = Math.round(parseFloat(value) * 100)

    return formatMoney(priceInCents, moneyFormat)
  }

  return (
    <p className={clsx(containerClass)}>
      {!isOnSale ? null : (
        <span className={clsx(priceClass, 'line-through text-neutral-tertiary')}>
          {formatPrice(compareAtPrice || '')}
        </span>
      )}

      <span className={clsx(priceClass, isOnSale ? 'text-brand-sale' : '')}>
        {formatPrice(price)}
      </span>
    </p>
  )
}
